import React, { useMemo } from 'react'
import { MenuItemType } from '@next-nx/utils/types'
import { WImage } from '@next-nx/shared-ui/atoms'
import styles from './ProdottoAmbientato.module.sass'

interface Props {
  item: MenuItemType
  className?: string
}

const ProdottoAmbientato = (props: Props) => {
  const { item = undefined, className = '' } = props

  const imageBox = useMemo(
    () =>
      item && (
        <WImage
          src={item.image}
          alt={item.name}
          title={item.name}
          maxWidth={635}
          maxHeight={476}
          layout="intrinsic"
        />
      ),
    [item?.image]
  )

  return item ? (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.bg} />
      {!!item.name && <p className={styles.title}>{item.name}</p>}
      {!!item.description && (
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: item.description }}
        />
      )}
      <div className={styles.imageBox}>
        {imageBox}
        <div className={styles.imageBg} />
      </div>
    </div>
  ) : (
    <></>
  )
}

export default ProdottoAmbientato
